import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
  }


  initialize(){
   document.addEventListener('turbolinks:before-visit', function(e){ e.preventDefault(); })

  }


  submit(e){
    e.preventDefault();
    document.removeEventListener('turbolinks:before-visit', function(e){e.preventDefault();})  
    window.open(e.detail[0].response);
    window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/tab_and_reload_controller.js